export var SpmValueTypes;
(function (SpmValueTypes) {
    SpmValueTypes["Current"] = "current";
    SpmValueTypes["Past"] = "past";
    SpmValueTypes["CurrentAvg"] = "currentAvg";
    SpmValueTypes["PastAvg"] = "pastAvg";
})(SpmValueTypes || (SpmValueTypes = {}));
//# sourceMappingURL=spm-value-types.enum.js.map